import React, {useEffect, useRef, useState} from 'react';
import {InfoModal} from "../../ui/InfoModal";
import BackgroundImage from "../../../assets/img/interns-recruitment-page-images/background.png";
import {Link} from "react-router-dom";
import {getResource, updateResource} from "../../service/http-service";


export const InternsVSSRecruitmentPage = ({recruitment, detailsList}) => {
    let user = sessionStorage.getItem('user')
    const [oglasi, setOglasi] = useState([])
    console.log(recruitment, detailsList)

    const getAppliedRecruitments = () => {
        getResource('candidates/get_applied_recruitment_for_logged_user').then((data) => {
            setOglasi(data.data.slice(-5).reverse())
            goToInternsCandidates()
        })
    }

    useEffect(()=> {
        getAppliedRecruitments();
    }, [])

    const handleSave = (recruitment) => {
        updateResource('candidates/apply_on_recruitment', recruitment).then((data) =>{
            if(data){
                alert('Успешно аплициравте на огласот')
                getAppliedRecruitments();
            }}
        ).catch((error) => {
            alert(error.response.data.message)
        }).finally(() => {
            console.log('vo finally')
        })
    }

    const InternsCandidatesRef = useRef(null);
    const goToInternsCandidates = () =>
        window.scrollTo({
            top: InternsCandidatesRef.current.offsetTop,
            behavior: "auto",
        });

    return (
        <div className="container-fluid m-0 p-0">
            <div className="row m-0 p-0 backgroundImage">
                <img src={BackgroundImage} className="backgroundImage m-0 p-0" alt="background-image" onLoad={() => goToInternsCandidates()}/>
                <div className="col-md-10 offset-md-1 col-12">
                    <div className="col-md-9 col-12 my-3 d-flex justify-content-start header-button-container" ref={InternsCandidatesRef}>
                        <div className="col-md-8 col-12 d-flex justify-content-start p-0 m-0">
                            <Link to="/career_opportunities/published" className="header-button-logIn all">
                                <div className="header-button-logIn-inner">Назад кон листата на огласи</div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-10 offset-md-1 mt-4 p-0 d-flex justify-content-between">
                <div className="col-md-8 col-12 p-0">
                    <div className="row m-0 p-0">
                        <div className="col-md-12">
                            <h2 className="published-title">{recruitment.name}</h2>
                        </div>
                    </div>
                    <div className="row m-0 p-0">
                        <div className="col-md-12 my-3 px-0 py-3 d-flex justify-content-start align-items-center flex-wrap published-info">
                            {detailsList.map(item => (<div className="regular-recruitment-text-published" key={item.sortNumber}>
                                <h6>{item.labelName}</h6>
                                <span>{item.elementValue}</span>
                            </div>))}
                        </div>
                    </div>

                    <div className="row m-0 p-0">
                        <div className="col-12">
                            {!recruitment.archive &&  <InfoModal btnText="Аплицирај" btnClass="apply-btn"  recruitment = {recruitment} handleSave = {()=>handleSave(recruitment)}>
                            </InfoModal>}
                        </div>
                    </div>
                    <div className="row m-0 p-0">
                        <div className="col-12">
                            <h3 className="regular-recruitment-headers">
                                Нашата програма вклучува:
                            </h3>
                            <div className="regular-recruitment-text">
                                {recruitment.offeredOpportunities}
                            </div>

                            <h3 className="regular-recruitment-headers">
                                Вие сте нашиот идеален кандидат доколку сте:
                            </h3>
                            <div className="regular-recruitment-text">
                                {recruitment.neededQualifications}
                            </div>

                            <h3 className="regular-recruitment-headers">
                                Услови за аплицирање:
                            </h3>
                            <div className="regular-recruitment-text">
                                {recruitment.requiredDocumentsForApplication}
                            </div>
                        </div>
                    </div>

                    <div className="row m-0 p-0">
                        <div className="col-md-12 m-0 p-0 d-flex justify-content-between align-items-center flex-wrap">
                            {!recruitment.archive &&  <InfoModal btnText="Аплицирај" btnClass="apply-btn"  recruitment = {recruitment} handleSave = {()=>handleSave(recruitment)}>
                            </InfoModal>}
                            <div className="d-flex justify-content-md-start justify-content-center flex-row-reverse">
                                <a className="zlp" href="https://alkaloid.com.mk/mk/zashtita-na-lichni-podatoci" target="_blank">
                                    <i className="fa fa-info-circle fa-3x"/>
                                </a>
                                <span className="info-zlp">Информации за Законот за заштита на лични податоци</span>
                            </div>
                        </div>
                    </div>
                </div>
                {(user && oglasi && oglasi.length > 0) &&  <div className="col-md-3 col-12 mt-3 d-flex justify-content-start align-content-end flex-wrap flex-column">
                    <div className="aplications">
                        <h5>ОГЛАСИ НА КОИ <br/>СУМ <span>АПЛИЦИРАЛ </span></h5>
                        <div className="pt-3 d-flex flex-column">
                            {oglasi.map(item => <p className="apliciran-oglas"
                                                   key={item.recruitment.id}>{item.recruitment.name}</p>)}
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
};

